import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_FAMILY_SETTINGS } from '@/api/endpoints';
import { FAMILY_SETTINGS_QUERY_KEY } from '@/api/queryKeys';
import type {
  FamilyMember,
  FamilyMemberResponse,
  FamilySettingsResponse,
} from '@/types/user';
import { unwrapAxiosResponse } from '@/utils/axios';

const toFamilyMember = ({
  personType,
  personTypeName,
  userProfile,
}: FamilyMemberResponse): FamilyMember => ({
  personType,
  personTypeName,
  userPublicId: userProfile?.userPublicId ?? null,
  phoneNumber: userProfile?.phoneNumber ?? null,
  emailAddress: userProfile?.emailAddress ?? null,
});

export const useFamilySettings = () =>
  useQuery<FamilySettingsResponse, Error, FamilyMember[]>({
    queryKey: FAMILY_SETTINGS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<FamilySettingsResponse>(API_FAMILY_SETTINGS)
        .then(unwrapAxiosResponse),
    select: (data) => data.familyMembers.map(toFamilyMember),
  });
